export default "__VITE_ASSET__C2fI95lk__"